module.exports = __webpack_public_path__ + "static/media/resize.a53369fb.svg";